module.exports = __webpack_public_path__ + "static/media/girl-19.dd2f282a.svg";